export default "__VITE_ASSET__c567e08b__"